import { certificationStatuses } from '../constants/filters';
export const parseCertificationStatusFilter = status => {
  return certificationStatuses.find(s => s === status.toUpperCase().replaceAll('-', '_')) || 'ACTIVE';
};